import React from "react";

const Navbar = () => {
  return (
    <nav className="bg-white flex justify-between py-6 px-16 sticky">
      <div>
        <a href="/"><p className="text-2xl font-bold text-slate-500">Car Rental</p></a>
      </div>
      <div>
        <i class="fa-solid fa-bars-staggered text-3xl cursor-pointer"></i>
      </div>
    </nav>
  );
};

export default Navbar;
